<template>
  <div class="w-full flex flex-col" style="min-height: 650px;">
    <div class="flex-1 min-h-0">
      <Bar
        ref="chartRef"
        :data="chartData"
        :options="chartOptions"
        :height="500"
      />
    </div>

    <div class="mt-4 text-center text-sm text-gray-500">
      Shipping Schedule • Promised Dates • Click bar to add to Outlook
    </div>
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  TimeScale
} from 'chart.js'
import 'chartjs-adapter-moment'
import moment from 'moment'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, TimeScale)

export default {
  name: 'ShippingScheduleChart',
  components: { Bar },

  props: {
    orders: { type: Array, required: true }
  },

  data() {
    return {
      chartData: { labels: [], datasets: [] },
      chartOptions: {}
    }
  },

  watch: {
    orders: {
      immediate: true,
      handler() {
        this.updateShippingChart()
      }
    }
  },

  methods: {
    updateShippingChart() {
      if (!this.orders?.length) return

      const validOrders = this.orders
        .filter(o => o.promised_Date)
        .sort((a, b) => new Date(a.promised_Date) - new Date(b.promised_Date))

      this.chartData = {
        labels: validOrders.map(o => `#${o.orderNo} - ${o.projName || ''}`),
        datasets: [{
          label: 'Shipping Window',
          data: validOrders.map(order => {
            const promised = moment(order.promised_Date)
            const start = moment(order.entered_Date || order.promised_Date).subtract(7, 'days')
            return [start.valueOf(), promised.valueOf()]
          }),
          backgroundColor: (ctx) => {
            const order = validOrders[ctx.dataIndex]
            return moment().isAfter(moment(order.promised_Date)) ? '#ef4444' : '#10b981'
          },
          borderColor: '#ffffff',
          borderWidth: 2,
          barThickness: 22,
          borderSkipped: false,
        }]
      }

      this.chartOptions = {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,

        onClick: (event, elements) => {
          if (elements.length > 0) {
            const index = elements[0].index
            this.addToOutlookCalendar(validOrders[index])
          }
        },

        plugins: {
          legend: { display: false },
          title: {
            display: true,
            text: 'Shipping Schedule - Gantt View',
            font: { size: 18, weight: 'bold' }
          },
          tooltip: {
            callbacks: {
              label: (ctx) => {
                const order = validOrders[ctx.dataIndex]
                return `Promised: ${moment(order.promised_Date).format('MMM D, YYYY')}`
              }
            }
          }
        },

        scales: {
          x: {
            type: 'time',
            time: {
              unit: 'day',
              tooltipFormat: 'MMM D, YYYY',
              displayFormats: { day: 'MMM D' }
            },
            title: { display: true, text: 'Date' },
            grid: { color: '#e5e7eb' }
          },
          y: {
            grid: { display: false },
            ticks: {
              font: { size: 11 },
              padding: 8
            }
          }
        }
      }
    },

    addToOutlookCalendar(order) {
      // (Your existing function - unchanged)
      const title = `Shipping - Order ${order.orderNo}`
      const startDate = moment(order.promised_Date).format('YYYY-MM-DD')
      const endDate = moment(order.promised_Date).add(1, 'day').format('YYYY-MM-DD')
      const details = `Order: ${order.orderNo}\nPO: ${order.customer_PO_No || 'N/A'}\nProject: ${order.projName || 'N/A'}`

      const outlookUrl = `https://outlook.live.com/calendar/0/deeplink/compose?subject=${encodeURIComponent(title)}&startdt=${startDate}&enddt=${endDate}&body=${encodeURIComponent(details)}`
      window.open(outlookUrl, '_blank')
    }
  }
}
</script>